/** Cart has exactly one line and that product id is in the delivery-promo list → shipping 0 MAD */
export function cartQualifiesForDeliveryPromo(
  cartDetails: Array<{ id: string | number }>,
  deliveryPromoProductIds: Set<string>
): boolean {
  if (cartDetails.length !== 1) return false;
  const productId = String(cartDetails[0].id);
  return deliveryPromoProductIds.has(productId);
}

export function resolveCheckoutShippingFee(
  baseFee: number,
  cartDetails: Array<{ id: string | number }>,
  deliveryPromoProductIds: Set<string>,
  hasFreeShippingPromoCode: boolean
): number {
  if (hasFreeShippingPromoCode) return 0;
  if (cartQualifiesForDeliveryPromo(cartDetails, deliveryPromoProductIds)) return 0;
  return Number(baseFee) || 0;
}
